import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { openSwAction, openEditerAction } from "../../redux/ui/actions";
import {
  changeSwModeAction,
  changeRegModeAction,
  changeInPredictAction,
} from "../../redux/app/actions";
import {
  changeDsAction,
  delDsAction,
  changeListCatAction,
  changeShowChkAction,
  changeSelRowAction,
  isDelAction,
  addDsAction,
  changeRegNumAction,
  changePreWLAction,
  changeNewDsAction,
} from "../../redux/boring/actions";
import Sw from "../common/Sw";
import Cat from "./Cat";
import Main from "./Main";
import jschardet from "jschardet";

const mapStateToProps = (state) => {
  return {
    swMode: state.appReducer.swMode,
    geoDs: state.geoReducer.dataset,
    regNum: state.boringReducer.regNum,
    ds: state.boringReducer.dataset,
    catData: state.boringReducer.catData,
    listCat: state.boringReducer.listCat,
    showChk: state.boringReducer.showChk,
    selRow: state.boringReducer.selRow,
    isDel: state.boringReducer.isDel,
    boringSw: state.uiReducer.boringSw,
    boringCatSw: state.uiReducer.boringCatSw,
    initNum: state.boringReducer.initNum,
    preWL: state.boringReducer.preWL,
    boringDs: state.boringReducer.dataset,
  };
};

class List extends Component {
  constructor(props) {
    super(props);
    this.zIndex = null;
    this.closeSw = this.closeSw.bind(this);
    this.openSw = this.openSw.bind(this);
    this.delDs = this.delDs.bind(this);
    this.openCatSw = this.openCatSw.bind(this);
    this.changeCat = this.changeCat.bind(this);
    this.changeShowChk = this.changeShowChk.bind(this);
    this.changeZIndex = this.changeZIndex.bind(this);
    this.changeRow = this.changeRow.bind(this);
    this.fileImport = this.fileImport.bind(this);

    this.tbRef = React.createRef();

    this.props.dispatch(changeSelRowAction(null));
  }

  componentDidUpdate(prevProps) {
    /*
     * 削除時データセットID・zIndexを修正
     * @since hara 2020-10-05
     */
    if (this.props.isDel) {
      /*
       * データセットID・zIndex修正
       */
      const ds = [...this.props.ds];

      ds.forEach((el, index) => {
        window.changeBoringName(el.ID, index + 1);
        if (this.zIndex < el.zIndex) el.zIndex = el.zIndex - 1;
        el.ID = index + 1;
        window.changeBoringIdx(el.ID, ds.length - el.zIndex);
      });
      this.props.dispatch(changeDsAction(ds));

      /*
       * 選択行移動
       */
      const trs = this.tbRef.childNodes;
      const rowNum = trs.length;
      const selRow = this.props.selRow;
      let newSelRow = null;

      if (selRow === rowNum) {
        //最終行削除の場合
        if (selRow !== 0) {
          //複数行の場合前の行を選択
          trs[rowNum - 1].click();
          newSelRow = rowNum - 1;
        }
        this.props.dispatch(changeSelRowAction(newSelRow));
      }

      this.props.dispatch(isDelAction(false));
    }
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    this.props.dispatch(openSwAction(null));
    this.props.dispatch(changeSwModeAction(0));
  }

  waiting = (stat) => {
    this.props.dispatch(changeInPredictAction(stat));
  };

  /*
   * サブウィンドウを開く
   * @param {Number} mode 0=新規/1=編集
   * @since hara 2020-09-09
   */
  openSw(mode) {
    if (mode === 1 && this.props.selRow === null) return; //編集で行未選択の場合
    if (mode === 1) {
      if (this.props.selRow < this.props.initNum) {
        alert("既存データセットは修正できません。");
      } else if (this.props.selRow + 1 == this.props.preWL) {
        alert("検証用ボーリングは修正できません。");
      } else {
        this.props.dispatch(openSwAction("boringMain"));
        this.props.dispatch(changeRegModeAction(mode));
      }
    } else {
      this.props.dispatch(openSwAction("boringMain"));
      this.props.dispatch(changeRegModeAction(mode));
    }
  }

  /*
   * データセット削除
   * @since hara 2020-09-30
   */
  delDs() {
    if (this.props.selRow < this.props.initNum) {
      alert("既存データセットは削除できません。");
    } else if (this.props.selRow + 1 == this.props.preWL) {
      alert("検証用ボーリングは削除できません。");
    } else if (this.props.selRow !== null) {
      const answer = window.confirm(
        "選択したデータセットを削除してもよろしいですか。"
      );
      if (answer) {
        let fileName = this.props.ds[this.props.selRow].name; // ファイル名を取得
        if (fileName.length == 0) {
          fileName = this.props.ds[this.props.selRow].uniq_id;
        }
        const origin = window.location.origin;
        const search = window.location.search;
        fetch(`${origin}/api/userboring/del/${search}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: fileName,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            window.delBoringLay(this.props.selRow + 1);
            if (this.props.selRow + 1 < this.props.preWL) {
              this.props.dispatch(changePreWLAction(this.props.preWL - 1));
            } else if (this.props.selRow + 1 == this.props.preWL) {
              this.props.dispatch(changePreWLAction(null));
            }
            this.zIndex = this.props.ds[this.props.selRow].zIndex;
            //ユーザーボーリングのフィーチャーのIDを振り直す
            window.changeBoringId(this.props.initNum);
            this.props.dispatch(delDsAction(this.props.selRow));
            this.props.dispatch(isDelAction(true));
            this.props.dispatch(changeRegNumAction(this.props.ds.length));
          })
          .catch((error) => {
            // エラーハンドリング
            console.error("An error occurred:", error);
          });
      }
    }
  }

  /*
   * 分類サブウィンドウを開く
   * @since hara 2020-10-20
   */
  openCatSw() {
    this.props.dispatch(openSwAction("boringCat"));
  }

  /*
   * 分類変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeCat(e) {
    this.props.dispatch(changeListCatAction(parseInt(e.target.value)));
  }

  /*
   * レイヤー表示変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeShowChk(e) {
    const val = e.target.value;
    const chk = e.target.checked;
    const ds = this.props.ds[val - 1];
    ds.vis = chk;
    ds.use = chk;
    window.changeBoringVis(val, chk);
    this.props.dispatch(changeShowChkAction(val, ds));
  }

  /*
   * 順序変更
   * @param {Number} cat 0=上/1=下
   * @since hara 2020-10-12
   */
  changeZIndex(cat) {
    if (this.props.selRow !== null) {
      const sel = this.props.selRow;
      const ds = [...this.props.ds];

      const val1 = cat === 0 ? -1 : 1;
      const val2 = cat === 0 ? 1 : -1;

      if (cat === 0 ? ds[sel].zIndex !== 1 : ds[sel].zIndex !== ds.length) {
        ds.forEach((el) => {
          if (el.zIndex === ds[sel].zIndex + val1) {
            el.zIndex = el.zIndex + val2;
          }
        });
        ds[sel].zIndex = ds[sel].zIndex + val1;
      }

      ds.forEach((el) => {
        window.changeBoringIdx(el.ID, ds.length - el.zIndex);
      });

      this.props.dispatch(changeDsAction(ds));
    }
  }

  /*
   * テーブル選択
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeRow(e) {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");

    this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
  }

  /*
   * ファイルインポート
   * @since ando 2024-03-22
   */
  async fileImport() {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (event) => {
      this.props.dispatch(openEditerAction(null)); //エディタを閉じる
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const fileSizeInBytes = file.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // バイトをMBに変換

      if (fileSizeInMB > 20) {
        alert("5MB以上のファイルはアップロードできません。");
        return;
      } else {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (event) => {
          const arrayBuffer = event.target.result;
          const byteArray = new Uint8Array(arrayBuffer);

          // Uint8Array を Buffer に変換
          const buffer = Buffer.from(byteArray);

          // jschardet でエンコーディングを判定（Buffer を渡す）
          const detected = jschardet.detect(buffer);
          // エンコーディングを判定後、必要に応じて処理
          let encoding = detected.encoding ? detected.encoding : "utf-8";
          if (
            [
              "ISO-8859-2",
              "ISO-8859-1",
              "windows-1252",
              "EUC-JP",
              "ISO-2022-JP",
              "CP932",
            ].includes(encoding)
          ) {
            encoding = "shift-jis"; // これらの場合、Shift-JIS に切り替える
          }
          const decoder = new TextDecoder(encoding);
          const contents = decoder.decode(new Uint8Array(arrayBuffer));
          //const contents = event.target.result;
          const fileName = file.name; // ファイル名を取得
          const fileNameWithoutExtension =
            fileName.lastIndexOf(".") !== -1
              ? fileName.substring(0, fileName.lastIndexOf("."))
              : fileName;
          const origin = window.location.origin;
          const search = window.location.search;

          //選択したハイパーパラメータのIDをDBに登録

          fetch(`${origin}/api/userboring/${search}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              file: contents,
              name: fileNameWithoutExtension,
              preWL: this.props.preWL,
            }),
          })
            .then((res) => res.json())
            .then((res) => {
              if (res.exist) {
                alert("同名のファイルはインポートできません。");
                this.waiting(false);
              } else if (res.no_columns) {
                const concatenatedColumns = res.no_columns.join(", ");
                alert(concatenatedColumns + "カラムが存在しません。");
                this.waiting(false);
              } else if (res.no_geo) {
                alert("地質情報に登録されていない地質が含まれます。");
                this.waiting(false);
              } else {
                let regNum = this.props.regNum;

                const dsLeng = res.length;
                const promises = res.map((el, index) => {
                  return new Promise((resolve) => {
                    window.createBoringLay(
                      el.data,
                      el.color,
                      regNum + 1,
                      el.vis,
                      dsLeng - el.zIndex
                    );
                    window.groupByData(el.data);
                    resolve();
                  });
                });
                Promise.all(promises)
                  .then(() => {
                    regNum += res.length;
                    this.props.dispatch(addDsAction(res));
                    this.props.dispatch(changeRegNumAction(regNum));
                    this.props.dispatch(changeNewDsAction(this.props.boringDs));
                    this.waiting(false);
                  })
                  .catch((error) => {
                    // エラーハンドリング

                    console.error("An error occurred:", error);
                  });
              }
            })
            .catch((err) => {
              console.log(err);
              alert("サーバーエラー");
              this.waiting(false);
            });
          // ファイルの内容を処理する
          //サーバーにファイルの内容を送信
        };
        const a = 1;
      }
    };
    fileInput.click();
  }

  render() {
    let tList = [];
    if (this.props.boringSw) {
      this.content = <Main />;
    } else if (this.props.boringCatSw) {
      this.content = <Cat />;
    } else {
      this.props.ds.forEach((el, index) => {
        const tr = (
          <tr id={index} key={index} onClick={this.changeRow}>
            <td>{el.ID}</td>
            <td>{window.abbreText(el.name, 11)}</td>
            <td>{window.abbreText(this.props.catData[el.cat].name, 11)}</td>
            <td>{window.abbreText(this.props.geoDs[el.geoInfo].name, 11)}</td>
            <td style={{ backgroundColor: el.color }}></td>
            <td className="l-textCenter">
              <input
                id={"boringList_showChk" + el.ID}
                className="check"
                type="checkbox"
                value={el.ID}
                onChange={this.changeShowChk}
                defaultChecked={this.props.ds[index].vis}
              />
              <label htmlFor={"boringList_showChk" + el.ID}></label>
            </td>
            <td>{el.zIndex}</td>
          </tr>
        );

        let vis = false;
        if (this.props.listCat === 0 || this.props.listCat - 1 === el.cat) {
          //全表示の場合または分類の場合
          tList.push(tr);
          if (el.vis) vis = true;
        }
        window.changeBoringVis(el.ID, vis);
        window.changeBoringIdx(el.ID, this.props.ds.length - el.zIndex);
      });

      this.content = (
        <Sw title="ボーリング" focusName="boring">
          {/*★ここから公開版で削除*/}
          {/*
                    <div className='btnWrap'>

                        <button className='sBtn l-mlS' onClick={this.delDs}>削除</button>
                        <div className='dividerV'></div>
                        <label>順序：</label>
                        <button className='sBtn' onClick={() => this.changeZIndex(0)}>上</button>
                        <button className='sBtn l-mlS' onClick={() => this.changeZIndex(1)}>下</button>
                    </div>

                    <div className='l-row l-mtS'>
                        <label>分類：</label>
                        <select className='selectM' value={this.props.listCat} onChange={this.changeCat}>
                            <option value='0'>全表示</option>
                            {this.props.catData.map((el, index) => (
                                el.ID !== 1 && <option value={el.ID} key={el.ID}>{el.ID + ' : ' + el.name}</option>
                            ))}
                        </select>
                        <button className='sBtn l-mlS' onClick={this.openCatSw}>設定</button>
                    </div>

                    {/*★ここまで公開版で削除*/}
          <div className="l-flex">
            <button className="sBtn" onClick={() => this.openSw(0)}>
              新規
            </button>
            <button className="sBtn l-mlS" onClick={() => this.openSw(1)}>
              修正
            </button>
            <button className="sBtn l-mlS" onClick={this.delDs}>
              削除
            </button>
            <button className="sBtn l-mlS" onClick={() => this.fileImport()}>
              インポート
            </button>
          </div>
          <div className="TWrapL l-mtS" style={{ overflowY: "scroll" }}>
            <table className="table">
              <thead>
                <tr>
                  <th className="tsS">ID</th>
                  <th>名称</th>
                  <th>分類</th>
                  <th>地質情報</th>
                  <th className="tsS">カラー</th>
                  <th className="tsS">表示</th>
                  <th className="tsS">順序</th>
                </tr>
              </thead>
              <tbody ref={(ref) => (this.tbRef = ref)}>{tList}</tbody>
            </table>
          </div>

          <div className="l-right l-mtM">
            <button className="cBtn" onClick={this.closeSw}>
              閉じる
            </button>
          </div>
        </Sw>
      );
    }

    return this.content;
  }
}

export default connect(mapStateToProps)(List);
